/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { BaseService } from '../../service/base';
import { EventDataResultDTO } from '../../service/event_service';

//-------------------------------------------------------------------------------------------------
// DTO Objects
//-------------------------------------------------------------------------------------------------
export interface PlowingDTO {
    assetId: string;
    lat: number;
    lon: number;
    timestamp: number;
    input1: boolean;
    input2: boolean;
    input3: boolean;
    input4: boolean;
}

//-------------------------------------------------------------------------------------------------

/** Main service class that handles calls to the server and caches data
 * where it can.
 *
 */
export class PlowingService extends BaseService {
    async getDailyData(startUTC: number, endUTC: number) {
        const response = await this.get<EventDataResultDTO[]>(this.url + '/api/' + this.orgid + '/plow/dailydata?start=' + startUTC + '&end=' + endUTC);
        return response;
    }
}
